import 'balloon-css';
// External CSS import here
import 'assets/css/main.css';
import 'rc-table/assets/index.css';
import 'public/block-ui.css';
import 'rc-collapse/assets/index.css';
import 'react-multi-carousel/lib/styles.css';
import '@redq/reuse-modal/lib/index.css';
import 'react-notifications/lib/notifications.css';
import 'react-dates/lib/css/_datepicker.css';
import 'pure-react-carousel/dist/react-carousel.es.css';
import 'react-multi-carousel/lib/styles.css';
import 'components/MultiCarousel/MultiCarousel.style.css';

import {ApolloProvider} from '@apollo/client';
import ProgressBar from '@badrap/bar-of-progress'
import * as Sentry from '@sentry/node';
import NextStorage from 'amplify-auth-next-storage';
import Amplify from 'aws-amplify';
import AdminContainer from "containers/AdminContainer";
import AppLayout from 'containers/LayoutContainer/AppLayout';
import {StickyProvider} from 'contexts/app/app.provider';
import {AuthProvider, getLoggedInUser} from 'contexts/auth/auth.provider';
import CartProvider from 'contexts/cart/cart.provider';
import LanguageProvider from 'contexts/language/language.provider';
import {ModalProvider} from "contexts/modal.provider";
import {SearchProvider} from 'contexts/search/search.provider';
import StockItemProvider from "contexts/stock/stock.provider";
import localAr from 'data/translation/ar.json';
import localDe from 'data/translation/de.json';
// Language translation files
import localEn from 'data/translation/en.json';
import localEs from 'data/translation/es.json';
import localIl from 'data/translation/he.json';
import localCn from 'data/translation/zh.json';
import {useApollo} from "helper/apollo";
import {useDeviceType} from 'helper/useDeviceType';
import App from 'next/app';
import Head from "next/head";
import Router from 'next/router'
import React from 'react';
import {NotificationContainer,} from 'react-notifications';
import {ThemeProvider} from 'styled-components';
import {GlobalStyle} from 'styled/global.style';
import {theme} from 'theme';

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
    Sentry.init({
        enabled: process.env.NODE_ENV === 'production',
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN
    });
}


// Language translation Config
const messages = {
    en: localEn,
    ar: localAr,
    es: localEs,
    de: localDe,
    zh: localCn,
    he: localIl,
};
const progress = new ProgressBar({
    size: 2,
    color: '#f15331',
    className: 'bar-of-progress',
    delay: 100,
});
Router.events.on('routeChangeStart', progress.start);
Router.events.on('routeChangeComplete', progress.finish);
Router.events.on('routeChangeError', progress.finish);

const awsconfig: any = process.env.AMPLIFY_CONFIG;


export function configureAmplify(ctx?) {
    Amplify.configure({
        ...awsconfig,
        Auth: {
            identityPoolId: awsconfig.aws_cognito_identity_pool_id,
            region: awsconfig.aws_project_region,
            identityPoolRegion: awsconfig.aws_project_region,
            userPoolId: awsconfig.aws_user_pools_id,
            userPoolWebClientId: awsconfig.aws_user_pools_web_client_id,
            mandatorySignIn: false,
            cookieStorage: {
                domain: process.env.BB_COOKIE_DOMAIN,
                path: '/',
                expires: 7,
                secure: process.env.BB_COOKIE_SECURE,
            },
            storage: new NextStorage(ctx, {
                domain: process.env.BB_COOKIE_DOMAIN,
                expires: 7,
                path: '/',
                secure: process.env.BB_COOKIE_SECURE,
            }),
            authenticationFlowType: 'USER_SRP_AUTH',
            clientMetadata: {myCustomKey: 'myCustomValue'},
            oauth: awsconfig.oauth
        }
    });
    // Analytics.autoTrack('pageView', {
    //     enable: true,
    // });
}


function isAdmin(pathname) {
    return pathname.includes('/admin')
}

export default function ExtendedApp({
                                        Component,
                                        pageProps,
                                        query,
                                        userAgent,
                                        userId,
                                        pathname,
                                        country,
                                        deviceType: cloudfrontDeviceType,
                                        err
                                    }) {
    const apolloClient = useApollo(pageProps.initialApolloState)
    const deviceType = process.env.NODE_ENV === 'production' ? cloudfrontDeviceType : useDeviceType(userAgent);

    configureAmplify();

    function getContent() {
        if (pathname.includes('admin')) return <AdminContainer>
            <Component {...pageProps} deviceType={deviceType} err={err}/>
        </AdminContainer>;
        if (pathname.includes('auth') || pathname.includes('index3'))
            return <Component {...pageProps}
                              err={err}
                              deviceType={deviceType}/>;
        // if (pathname.includes('account') || pathname.includes('checkout')) return <CustomerPortalContainer>
        //     <Component {...pageProps} deviceType={deviceType}/>
        // </CustomerPortalContainer>;
        return <>

            <AppLayout deviceType={deviceType}>
                <Component {...pageProps} deviceType={deviceType} err={err}/>
            </AppLayout>
            <GlobalStyle/>
        </>;
    }

    return (
        <>
            <Head>
                <meta key="fb:app_id" property="fb:app_id" content={"343472203701213"}/>
                <meta key="og:url" property="og:url" content={process.env.BASE_URL}/>
                <meta key="og:type" property="og:type" content="website"/>
                <meta key="og:title" property="og:title"
                      content={`Rent top quality outdoor, camping and travel products. Delivered to your door.`}/>
                <meta key="og:description" property="og:description"
                      content="Rent top quality outdoor, camping and travel products. Delivered to your door."/>
                <link
                    href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&display=swap"
                    rel="stylesheet"/>

                <script
                    dangerouslySetInnerHTML={{
                        __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-NK8JZSQ');`,
                    }}
                />


                <script
                    async
                    src={`https://www.googletagmanager.com/gtag/js?id=${process.env.GA_TRACKING_ID}`}
                />
                <script
                    dangerouslySetInnerHTML={{
                        __html: `
                                    window.dataLayer = window.dataLayer || [];
                                    function gtag(){dataLayer.push(arguments);}
                                    gtag('js', new Date());
                                    gtag('config', '${process.env.GA_TRACKING_ID}', {
                                      page_path: window.location.pathname,
                                    });
                                  `,
                    }}
                />


                {/*PureChat Widget*/}
                {/* {!isAdmin(pathname) && <script type='text/javascript' data-cfasync='false'
                                               dangerouslySetInnerHTML={{__html: `window.purechatApi = { l: [], t: [], on: function () { this.l.push(arguments); } }; (function () { var done = false; var script = document.createElement('script'); script.async = true; script.type = 'text/javascript'; script.src = 'https://app.purechat.com/VisitorWidget/WidgetScript'; document.getElementsByTagName('HEAD').item(0).appendChild(script); script.onreadystatechange = script.onload = function (e) { if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) { var w = new PCWidget({c: '5a8eca6e-58f3-46b3-a34b-2b3f75fc5c0f', f: true }); done = true; } }; })();`}}/>} */}


                {/* HotJar Widget*/}
                {!isAdmin(pathname) && <script type='text/javascript'
                                               dangerouslySetInnerHTML={{
                                                   __html: `
                                     
                                            (function(h,o,t,j,a,r){
                                                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                                                h._hjSettings={hjid:978597,hjsv:6};
                                                a=o.getElementsByTagName('head')[0];
                                                r=o.createElement('script');r.async=1;
                                                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                                                a.appendChild(r);
                                            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
                                        `
                                               }}/>}

            </Head>
            <ApolloProvider client={apolloClient}>
                <ThemeProvider theme={theme}>
                    <LanguageProvider messages={messages}>
                        <StockItemProvider>
                            <CartProvider>
                                <SearchProvider query={query}>
                                    <StickyProvider>
                                        <AuthProvider viewerCountry={country} userId={userId} deviceType={deviceType}>
                                            <NotificationContainer/>
                                            <ModalProvider>
                                                {getContent()}
                                            </ModalProvider>
                                        </AuthProvider>
                                    </StickyProvider>
                                </SearchProvider>
                            </CartProvider>
                        </StockItemProvider>
                    </LanguageProvider>
                </ThemeProvider>
            </ApolloProvider>
        </>
    );
}

ExtendedApp.getInitialProps = async appContext => {
    const appProps = await App.getInitialProps(appContext);
    const {req, query} = appContext.ctx;
    const user = await getLoggedInUser(appContext);
    const userAgent = req ? req.headers['user-agent'] : navigator.userAgent;
    const country = appContext.ctx.req?.headers['cloudfront-viewer-country'] || 'ZA';
    const postalCode = appContext.ctx.req?.headers['cloudfront-viewer-postal-code'];
    const deviceType = {
        mobile: (appContext.ctx.req?.headers['cloudfront-is-mobile-viewer']) === 'true',
        desktop: (appContext.ctx.req?.headers['cloudfront-is-desktop-viewer']) === 'true',
        tablet: (appContext.ctx.req?.headers['cloudfront-is-tablet-viewer']) === 'true',
    };

    console.log('viewer', country, postalCode);

    return {
        ...appProps,
        userAgent,
        query,
        deviceType,
        userId: user?.getUsername(),
        company: user?.attributes['custom:company'],
        pathname: appContext.router?.pathname,
        country
    };
};

